<template>
    <div class="page-container">
        <!--        <img class="buy-nft-bg" src="../../images/nft_bg.webp">-->
        <div class="resonance-page-container">
            <div class="resonance-header">{{ this.localize('参与共振流动性') }}</div>
            <div v-if="this.tokenList.length === 0" class="empty-page-container">
                <img class="empty-page-img" src="../../images/empty.svg" alt="empty">
                <div class="empty-page-txt">{{ this.localize('空') }}</div>
            </div>

            <template v-else>
                <template v-for="(item, index) in this.tokenList" :key="index">
                    <div class="nft-card-container"
                         v-if="this.getNftStateCode(item) !== -1">

                        <div class="nft-state"
                             :class="{ 'active': this.getNftStateCode(item) !== 0, 'disabled': this.getNftStateCode(item) === 2 || this.getNftStateCode(item) === 3 || this.getNftStateCode(item) === 4}">
                            {{ item.stateDisplay }}
                        </div>
                        <div class="nft-card-wrapper">
                            <img class="nft-card-img" :src="item.image" alt="nft">
                            <div class="nft-des-container">
                                <div class="nft-des-item"><span>{{ this.localize('类型：') }}</span> <span>{{ item.name }}</span></div>
                                <div class="nft-des-item"><span>{{ this.localize('创建时间：') }}</span> {{ item.createdTimeString }}</div>
                                <div class="nft-des-item"><span>{{ this.localize('总能量：') }}</span> {{ item?.energy?.toFixed(1) }}</div>
                                <div class="nft-des-item"><span>{{ this.localize('剩余用能量：') }}</span>
                                    {{ Number(item?.energyRemain)?.toFixed(1) }}
                                </div>
                                <div class="nft-des-item"><span>{{ this.localize('算力：') }}</span> {{ item?.computingPower?.toFixed(1) }}
                                </div>
                                <div class="nft-des-item"><span>{{ this.localize('燃料：') }}</span> {{ item?.fuel?.toFixed(getToFixed()) }}</div>
                                <div class="nft-des-item"><span>{{ this.localize('次数：') }}</span> {{ item.round }}
                                </div>
                            </div>
                        </div>
                        <div class="start-resonance-btn"
                             v-if="item.stateCode >0 || this.canStartResonance === true"
                             @click="viewNftDetail(item)">
                            {{ this.localize('详情') }}
                        </div>
                    </div>

                </template>
            </template>

        </div>
    </div>
</template>
<script>

import {
    fetchOwnerNFTTokens,
    getNFTInfo,
    startResonance,
    getTierPrice,
    checkAllowance, approveUSDT, withdrawResonanceDeposit,
    getNftResonanceRewardExpireTime,
    getNftResonancePeriod,
    getNftExpireTime,
    nftEthCall,
    usdtEthCall, sendInteractorTrans
} from "@/utils/web3Helper";
import {getFormatedCountdownTime, sleep, getNftStateCode, getToFixed} from "@/utils/methods";
import {hideLoading, showLoading} from "@/utils/spinnerHelper";
import {showToast} from "@/utils/toastHelper";
import {Interactor} from '@/utils/constants';

import {parseUnits, formatUnits} from 'ethers'
import {postRequestAsync} from "@/utils/request";
import {v4} from "uuid"

const moment = require('moment-timezone')
const macau = require('../../images/nft/macau.webp')
const dubai = require('../../images/nft/dubai.webp')
const monaco = require('../../images/nft/monaco.webp')
const lasvegas = require('../../images/nft/lasvegas.webp')

export default {
    name: 'ResonancePage',
    props: {
        msg: String
    },
    inject: ['langStore', 'localize'],
    async mounted() {
        try {
            const loadingId = v4()
            showLoading(this.localize('加载中'), loadingId)
            console.log(`this.myWalletAddress: ${this.myWalletAddress}`)
            const tmp = await getNftResonanceRewardExpireTime()
            this.nftResonanceRewardExpireTime = Number(tmp)
            this.resonancePeriod = Number(await getNftResonancePeriod())
            this.nftExpireTime = Number(await getNftExpireTime())
            if (this.myWalletAddress) {
                await this.initPage()
            }
        } finally {
            hideLoading('all')
        }
    },
    watch: {
        async myWalletAddress(newVal, oldVal) {
            console.log('watch myWalletAddress')
            if (!newVal) return
            if (newVal === oldVal) return
            await this.initPage()
        }
    },
    computed: {
        myWalletAddress() {
            return this.$store.state.connectedWallet
        },
    },
    data() {
        return {
            myTokenIds: [],
            tokenList: [],
            imgUrl: {
                '0': macau,
                '1': dubai,
                '2': monaco,
                '3': lasvegas

            },
            canStartResonance: true,
            resonanceCountdownInterval: null,
            nftResonanceRewardExpireTime: null,
            resonancePeriod: null,
            nftExpireTime: null
        }
    },
    methods: {
        getToFixed,
        async initPage() {
            const loadingId = v4()
            showLoading(this.localize('加载中'), loadingId)
            try {
                this.myTokenIds = await fetchOwnerNFTTokens(this.myWalletAddress)
                if (this.myTokenIds?.length > 0) {
                    const localTokenList = []
                    for (const item of this.myTokenIds) {
                        const tokenInfo = await getNFTInfo(item)
                        const toPush = {
                            name: tokenInfo['2'],
                            tokenId: item,
                            nftType: Number(tokenInfo['0']),
                            image: this.imgUrl[Number(tokenInfo['0'])],
                            energy: Number(tokenInfo['3']) / Math.pow(10, 18),
                            energyUsed: Number(tokenInfo['4']) / Math.pow(10, 18),
                            energyRemain: formatUnits(tokenInfo['3'] - tokenInfo['4'], 18),
                            computingPower: Number(tokenInfo['5']) / Math.pow(10, 18),
                            fuel: Number(tokenInfo['6']) / Math.pow(10, 18),
                            resonanceDeposit: formatUnits(tokenInfo['6'] / 2n * 15n / 10n, 18),
                            startResonanceTime: parseInt(tokenInfo['7']),
                            startResonanceTimeString: moment(parseInt(tokenInfo['7'])).tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss'),
                            createdTimeString: moment(Number(tokenInfo['1']) * 1000).tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss'),
                            resonanceDepositWithdrawTimestamp: parseInt(moment(Number(tokenInfo['8']) * 1000).format('X')),
                            round: tokenInfo['9'],
                        }

                        const nftStateCode = this.getNftStateCode(toPush)

                        toPush.stateCode = nftStateCode

                        if (nftStateCode > 0) {
                            this.canStartResonance = false
                        }
                        toPush.stateDisplay = this.getNftState(toPush)
                        localTokenList.push(toPush)
                        console.log(`nftStateCode: ${nftStateCode}`)

                    }
                    this.tokenList = localTokenList

                    this.$store.dispatch('setMyNFTList', {
                        nftList: localTokenList
                    })

                }
            } finally {
                hideLoading(loadingId)
            }
            this.createInterval()

        },
        createInterval() {
            if (this.resonanceCountdownInterval) {
                clearInterval(this.resonanceCountdownInterval)
            }
            this.resonanceCountdownInterval = setInterval(() => {
                for (const nft of this.tokenList) {
                    nft.stateDisplay = this.getNftState(nft)
                    nft.stateCode = this.getNftStateCode(nft)
                    if (nft.stateCode > 0) {
                        this.canStartResonance = false
                    }
                }
            }, 1000)
        },
        getNftState(item) {
            const stateCode = getNftStateCode(item, this.resonancePeriod, this.nftExpireTime, this.nftResonanceRewardExpireTime)
            const currentTimestamp = parseInt(moment().format('X'))
            switch (stateCode) {
                case 0:
                    return this.localize('未开始')
                case 1:
                    return this.localize(`共振中`)
                case 2:
                    return this.localize(`异常`)
                case 3:
                    return this.localize(`异常`)
                case 4:
                    return this.localize(`异常`)
                case -1:
                case -2:
                    return this.localize(`NFT已经失效`)
            }
        },
        getNftStateCode(item) {
            return getNftStateCode(item, this.resonancePeriod, this.nftExpireTime, this.nftResonanceRewardExpireTime)
        },
        async startResonance(item) {
            if (item.stateCode !== 0 && item.stateCode !== 3 && item.stateCode !== 4) {
                return
            }
            const loadingId = v4()
            showLoading(this.localize('操作中'), loadingId)
            try {
                const resonanceDeposit = parseUnits(item.resonanceDeposit.toString(), 18)
                const allowance = BigInt(await usdtEthCall('allowance', [this.myWalletAddress, Interactor]))

                console.log(`allowance: ${allowance}`)
                console.log(`resonanceDeposit: ${resonanceDeposit}`)
                if (allowance < resonanceDeposit) {
                    const {success} = await approveUSDT(Interactor, formatUnits(resonanceDeposit, 18))
                    if (success !== true) {
                        showToast(this.localize('授权失败'))
                        hideLoading()
                        return
                    }
                    showToast(this.localize('授权成功'))
                    await sleep(3000)
                }
                const sigResult = await postRequestAsync('sig/getResonanceSig',
                    {wallet: this.myWalletAddress, tokenId: item.tokenId})

                if (sigResult?.code !== 200 || sigResult?.msg?.nonce === null || !sigResult?.msg?.timestamp || !sigResult?.msg?.deadline || !sigResult?.msg?.signature) {
                    showToast(this.localize('获取数据失败'))
                    hideLoading()
                    return
                }
                const {success} = await startResonance(item.tokenId, sigResult?.msg?.nonce, sigResult?.msg?.timestamp, sigResult?.msg?.deadline, sigResult?.msg?.signature)

                if (success === true) {
                    await sleep(3000)
                    showToast(this.localize('操作成功'))
                    await this.initPage()
                } else {
                    showToast(this.localize('操作失败'))
                }
            } finally {
                hideLoading(loadingId)
            }
        },
        async withdrawResonanceDeposit(item) {
            const loadingId = v4()
            showLoading(this.localize('操作中'), loadingId)
            try {
                console.log(`tokenId: ${item.tokenId}`)
                const triggerAmount = await nftEthCall('resonanceRefundDepositTriggerAmount', [item.nftType])
                console.log(`triggerAmount: ${triggerAmount}`)
                const allowance = await usdtEthCall('allowance', [this.myWalletAddress, Interactor])
                console.log(`allowance: ${allowance}`)
                console.log(`triggerAmount: ${triggerAmount}`)
                if (BigInt(allowance) < BigInt(triggerAmount)) {
                    const {success} = await approveUSDT(Interactor, formatUnits(triggerAmount.toString(), 18))
                    if (success !== true) {
                        showToast(this.localize('授权失败'))
                        hideLoading(loadingId)
                        return
                    }
                    await sleep(3000)
                    showToast(this.localize('授权成功'))
                }
                const sigResult = await postRequestAsync('sig/getResonanceSig',
                    {wallet: this.myWalletAddress, tokenId: item.tokenId})

                if (sigResult?.code !== 200 || sigResult?.msg?.nonce === null || !sigResult?.msg?.timestamp || !sigResult?.msg?.deadline || !sigResult?.msg?.signature) {
                    showToast(this.localize('获取数据失败'))
                    hideLoading(loadingId)
                    return
                }
                const {success} = await sendInteractorTrans('withdrawNftResonanceDeposit', [item.tokenId, sigResult?.msg?.nonce, sigResult?.msg?.timestamp, sigResult?.msg?.deadline, sigResult?.msg?.signature])
                if (success === true) {
                    await sleep(3000)
                    showToast(this.localize('操作成功'))
                    await this.initPage()
                } else {
                    showToast(this.localize('操作失败'))
                }
            } finally {
                hideLoading(loadingId)
            }
        },
        viewNftDetail(item) {
            this.$router.push({
                name: 'resonanceDetail',
                query: {
                    tokenId: item.tokenId
                }
            })
        }
    }
}
</script>
<style scoped>

.resonance-page-container {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    gap: 1em;
    padding: 7em 1em;
    border-radius: 0.4em;
}

.resonance-header {
    font-size: 2em;
    color: #38FF59;
}

.empty-page-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 2em;
    box-sizing: border-box;
    align-items: center;
}

.empty-page-img {
    width: 10em;
    opacity: 0.3;
}

.empty-page-txt {
    font-size: 2em;
    color: #48FFA1;
    opacity: 0.3;
}

.nft-card-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0.8em;
    box-sizing: border-box;
    border: 1px solid #E3E3E3;
    border-radius: 0.4em;
    gap: 0.6em;
    align-items: center;
}

.nft-card-container.active {
    border-color: #48FFA1;
}

.nft-card-container.disabled {
    border-color: #ff4848;
}

.nft-card-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    border-radius: 0.4em;
    gap: 1em;
}

.nft-des-container {
    flex: 1;
    align-items: start;
    display: flex;
    flex-direction: column;
    color: #dadada;
    gap: 0.2em;
}

.nft-card-img {
    width: 8em;
}

.nft-des-item {
    font-size: 1.2em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}

.start-resonance-btn {
    background-color: #38FF59;
    color: #ffffff;
    width: fit-content;
    font-size: 1.6em;
    line-height: 1.4em;
    padding: 0.2em 0.8em;
    border-radius: 0.1em;
}

.start-resonance-btn-container {
    width: 100%;

}

.nft-state {
    color: #9D9D9D;
    font-size: 1.6em;
}

.nft-state.active {
    color: #38FF59;
}

.nft-state.disabled {
    color: #ff4848;
}

.show-detail {
    color: #48FFA1;
    font-size: 1.4em;
}

.page-container {
    background: #8E8261;
    background: linear-gradient(180deg, rgba(142, 130, 97, 1) 0%, rgba(9, 7, 2, 1) 100%);
}
</style>